import course1Thumbnail from '../assets/images/Courses/Course1.png';
import course2Thumbnail from '../assets/images/Courses/Course2.png';

export const courses = [
  {
    id: 'course-1',
    title: 'Arabic Course - Beginner Level',
    description: 'Learn to understand the basics of the Arabic language and how to read the Quran.',
    playlistUrl: 'https://www.youtube.com/playlist?list=PLj56qR11Y1cnUKXiurKlJqLbVOu8uPjna',
    thumbnail: course1Thumbnail,
    lectures: [
      {
        videoUrl: 'https://www.youtube.com/watch?v=je2CITizJ_k',
        title: 'Lecture 1',
      },
      {
        videoUrl: 'https://www.youtube.com/watch?v=xOvmUmHllSo',
        title: 'Lecture 2',
      },
      {
        videoUrl: 'https://www.youtube.com/watch?v=9EYYZ7i6MY4',
        title: 'Lecture 3',
      },
      {
        videoUrl: 'https://www.youtube.com/watch?v=wRfkV6rNB0M',
        title: 'Lecture 4',
      },
      {
        videoUrl: 'https://www.youtube.com/watch?v=_1hZh8HkbbI',
        title: 'Lecture 5',
      },
      {
        videoUrl: 'https://www.youtube.com/watch?v=-ZQQHXv9XnU',
        title: 'Lecture 6',
      },
      {
        videoUrl: 'https://www.youtube.com/watch?v=U9izqowygYs',
        title: 'Lecture 7',
      },
      {
        videoUrl: 'https://www.youtube.com/watch?v=eJ3I2_okWng',
        title: 'Lecture 8',
      },
      {
        videoUrl: 'https://www.youtube.com/watch?v=PuW_vHvHL6g',
        title: 'Lecture 9',
      },
      {
        videoUrl: 'https://www.youtube.com/watch?v=rLj2d-dHuEs',
        title: 'Lecture 10',
      },
      {
        videoUrl: 'https://www.youtube.com/watch?v=Km2PjwA1Zks',
        title: 'Lecture 11',
      },
      {
        videoUrl: 'https://www.youtube.com/watch?v=YR8W3qJSTyc',
        title: 'Lecture 12',
      },
      {
        videoUrl: 'https://www.youtube.com/watch?v=pqBghPprKK0',
        title: 'Lecture 13',
      },
      {
        videoUrl: 'https://www.youtube.com/watch?v=oq6RUlz3Eeo',
        title: 'Lecture 14',
      },
      {
        videoUrl: 'https://www.youtube.com/watch?v=PPzoU9zxrN8',
        title: 'Lecture 15',
      },
    ],
  },
  {
    id: 'course-2',
    title: 'Islamic Fiqh Course',
    description: 'Deep dive into Islamic teachings and practical applications. This course aims to equip you with the knowledge to practice Islam correctly and meaningfully.',
    playlistUrl: 'https://www.youtube.com/playlist?list=PLj56qR11Y1cnTOc316gfDqNxMVOT74K-H',
    thumbnail: course2Thumbnail,
    lectures: [
      {
        videoUrl: 'https://www.youtube.com/watch?v=1KrxjBtca30',
        title: 'Lecture 1',
      },
      {
        videoUrl: 'https://www.youtube.com/watch?v=1iqoYNKqoAE',
        title: 'Lecture 2',
      },
      {
        videoUrl: 'https://www.youtube.com/watch?v=bJKyLcEEehU',
        title: 'Lecture 3',
      },
      {
        videoUrl: 'https://www.youtube.com/watch?v=UwuZQ1KqX_M',
        title: 'Lecture 4',
      },
      {
        videoUrl: 'https://www.youtube.com/watch?v=y4Ib_4LDVxA',
        title: 'Lecture 5',
      },
      {
        videoUrl: 'https://www.youtube.com/watch?v=CI8Ld_YKjtg',
        title: 'Lecture 6',
      },
      {
        videoUrl: 'https://www.youtube.com/watch?v=cj4516YJDrA',
        title: 'Lecture 7 | Namaz, Salah',
      },
      {
        videoUrl: 'https://www.youtube.com/watch?v=hnP24VwVmYU',
        title: 'Lecture 8 | Qurbani & Eid ul Azha',
      },
      {
        videoUrl: 'https://www.youtube.com/watch?v=BLmsK1e57aA',
        title: 'Lecture 9 | Qurbani & Eid ul Azha',
      },
      {
        videoUrl: 'https://www.youtube.com/watch?v=gQPRvmqgEpY',
        title: 'Lecture 10 | Namaz, Salah',
      },
      {
        videoUrl: 'https://www.youtube.com/watch?v=uzyJFhT1Tdc',
        title: 'Lecture 11 | Zakat',
      },
      {
        videoUrl: 'https://www.youtube.com/watch?v=0v-JXHI4XSg',
        title: 'Lecture 12 | Roza, Sawm',
      },
      {
        videoUrl: 'https://www.youtube.com/watch?v=4-yMvxw8SKM',
        title: 'Lecture 13 | Hajj',
      },
      {
        videoUrl: 'https://www.youtube.com/watch?v=N3OTEJGz1zQ',
        title: 'Lecture 14 | Hajj & Qasam (Swearing)',
      },
      {
        videoUrl: 'https://www.youtube.com/watch?v=PeJB4TArUUI',
        title: 'Lecture 15 | Taharat, Najasat',
      },
      {
        videoUrl: 'https://www.youtube.com/watch?v=_3zRqFpWJyk',
        title: 'Lecture 16 | Taharat, Najasat, Istanja, Ghusl, Wazu',
      },
      {
        videoUrl: 'https://www.youtube.com/watch?v=UfcKuiXbHHM',
        title: 'Lecture 17 | Tayyamum',
      },
      {
        videoUrl: 'https://www.youtube.com/watch?v=yR0JVHTCn3I',
        title: 'Lecture 18 | Rules of Sale',
      },
    ],
  },
];
